import Api from '../../services';

export const uploadMedia = (data) => {
  return (dispatch) => {
    return Api.contactUs.uploadMedia(data).then((response) => {
      dispatch({
        type: 'UPLOAD_MEDIA',
        data: response,
      });
      return response;
    });
  };
};

export const contactUs = (data) => {
  return (dispatch) => {
    return Api.contactUs.contactUs(data).then((response) => {
      dispatch({
        type: 'CONTACT_US',
        data: response,
      });
      return response;
    });
  };
};
